import axios from "axios";
import { generateAuthenticationDetails } from "../../utils/generateAuthInfo";
import { store } from "../../store";
import { cleanupUserSettings } from "../../store/slice/auth-slice";


// export const baseURL = "https://simpldtestapi.banyaniot.co.in/";
export const baseURL = "https://api.simpld.in/";
// export const baseURL = "http://localhost:3005/";

export const api = axios.create({
  baseURL: baseURL + "api/",
});

// Request interceptor
api.interceptors.request.use(async (config) => {
  const { timestamp, securityCode } = generateAuthenticationDetails();

  // Prefer a per-request Authorization (e.g. forgot-password reset passes the
  // short-lived OTP token via headers). Otherwise fall back to the logged-in
  // user's token. Always append `|timestamp,securityCode` so the backend's
  // protect middleware verifies the request instead of falling back to the
  // hard-coded dummy when the pipe is missing.
  const requestAuth = config.headers?.Authorization;
  let jwt = "";
  if (typeof requestAuth === "string" && requestAuth.startsWith("Bearer ")) {
    jwt = requestAuth.slice(7).split("|")[0].trim();
  } else {
    jwt = localStorage.getItem("token") || "";
  }

  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${jwt}|${timestamp},${securityCode}`,
  };
  return config;
});

// A clinic left signed in past its grace period gets 403 "plan has ended" on
// every call. Re-read the profile once so the app switches to the renew screen
// instead of showing a page of failed requests.
let refreshingForLock = false;
const PLAN_ENDED = /Please renew to continue|free trial has ended/i;

// Response interceptor
api.interceptors.response.use(
  (response) => {
    // Successful response
    return response;
  },
  async (error) => {
    // A 401 from the login endpoint itself means "bad credentials" — let the
    // caller surface a toast. Only treat 401s on other endpoints as an
    // expired/invalid session and hard-redirect to /login.
    const url = error.config?.url || "";
    const isLoginCall = /(^|\/)auth\/login(_switch)?$/.test(url);

    if (
      error.response?.status === 403 &&
      PLAN_ENDED.test(String(error.response?.data?.error || "")) &&
      !refreshingForLock
    ) {
      refreshingForLock = true;
      import("../../utils/refreshProfile")
        .then((m) => m.refreshProfile())
        .catch(() => {})
        .finally(() => {
          refreshingForLock = false;
        });
    }

    if (error.response?.status === 401 && !isLoginCall) {
      store.dispatch(cleanupUserSettings());
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);
